export default class NominatimService {

    async getInfo(lat, lon) {
        const response = await fetch(`https://nominatim.openstreetmap.org/reverse.php?lat=${lat}&lon=${lon}&zoom=18&format=jsonv2&accept-language=uk`);
        return await response.json();
    }
}